import request from '@/utils/request'

/**
 * 新增新闻
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function newsAdd(data) {
  return request({
    type: 'biz',
    url: 'news/add',
    method: 'post',
    data
  })
}

/**
 * 删除新闻
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function newsDelete(data) {
  return request({
    type: 'biz',
    url: 'news/delete',
    method: 'post',
    data
  })
}

/**
 * 获取新闻信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function newsDetailGet(data) {
  return request({
    type: 'biz',
    url: 'news/detail/get',
    method: 'post',
    data
  })
}

/**
 * 获取新闻信息(内部)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function newsInnerDetailGet(data) {
  return request({
    type: 'biz',
    url: 'news/inner/detail/get',
    method: 'post',
    data
  })
}

/**
 * 获取新闻分页(内部)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function newsInnerPageGet(data) {
  return request({
    type: 'biz',
    url: 'news/inner/page/get',
    method: 'post',
    data
  })
}

/**
 * 获取新闻分页
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function newsPageGet(data) {
  return request({
    type: 'biz',
    url: 'news/page/get',
    method: 'post',
    data
  })
}

/**
 * 修改新闻
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function newsUpdate(data) {
  return request({
    type: 'biz',
    url: 'news/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/News.js